module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAAAsSAAALEgHS3X78AAAA70lEQVQoFXWSvVEDMRCFP24owB3gDmwqwE6lwHYHVwLECoBAuTsAOnAipeAOjg6gAweEzBzzhj1Gd8gvWWnej1YrXfR9Tw0+xzmwBFS75MJbTfcvwOc4A56BzUT7CbTToFGAmSVYVNv6xXVyoRs2lxPytjDfWf0CvoGthZ9Kw1+Az3FpogE65dXW6+RCyY0DfI6Hyp2FR51YG6DPcQV8ND7HhzNm4V6iirm17lp1oKRzOCrADLrCUJ+Ad2CvgNFQCuyN0z/Q66hLzeXKzKvkwqkxYQ16jRvxyQVpXqZmiRob0M6IGmYaWHJB7a9LM8AP1wtTLmaC5eMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/bimstream_approved.png
// module id = YJrV
// module chunks = 1